<template>
  <div class="pro-user-statistics">
    <el-row type="flex" justify="space-between">
      <span style="font-weight: bold; font-size: 1.2em;">人员统计分析</span>
      <el-button plain @click="$emit('update:modelValue')" icon="back">返回</el-button>
    </el-row>

    <el-row justify="space-between">
      <worker-status-statistics :statisticsData="statisticsData.workerStatus" />
      <age-range-statistics :statisticsData="statisticsData.ageRanges" />
      <user-statistics :statisticsData="statisticsData.sex" />
    </el-row>

    <el-row justify="space-between">
      <entry-trend-statistics :statisticsData="statisticsData.entryTrend" />
      <region-statistics :statisticsData="statisticsData.province" />
    </el-row>
    
  </div>
</template>

<script>
import { getProUserStatustics } from '@/api/proman/prouser';
import { defineComponent } from 'vue';

import WorkerStatusStatistics from './WorkerStatus.vue';
import AgeRangeStatistics from './AgeRange.vue';
import UserStatistics from './Sex.vue';
import RegionStatistics from './Region.vue';
import EntryTrendStatistics from './EntryTrend.vue';

export default defineComponent({
  emits: ['update:modelValue'],
  components: { WorkerStatusStatistics, AgeRangeStatistics, UserStatistics, EntryTrendStatistics, RegionStatistics },
  props: {
    project: Object,
    queryParams: Object,
    modelValue: Boolean
  },
  data() {
    return {
      statisticsData: {}
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getProUserStatustics(this.queryParams).then(({data}) => {
        this.statisticsData = data.data;
      }).catch(_ => {})
    }
  }
})
</script>

<style lang="scss" scoped>
.pro-user-statistics {
  padding: 20px;
  .el-row + .el-row {
    margin-top: 25px;
  }
}
</style>
